import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import { IconHexagon, IconLock } from 'src/Components/shared/Icon'
import { Button, Format, If, Lock, Text } from 'src/Components'
import { handleKeyNavForward } from 'src/helpers/input'

import styles from './Gem.module.scss'

const Amount = ({ className, value, color, qualified, inCarousel }) => (
  <Text
    className={classnames(
      className,
      styles.amount,
      !qualified && styles.disabled
    )}
    element='div'
    size={inCarousel ? 'xxl' : 'l'}
    weight={inCarousel ? 'light' : 'regular'}
    align='center'
    color={color}
  >
    <Format.Currency abbreviate value={value} />
  </Text>
)

Amount.defaultProps = {
  color: 'green'
}

const Gem = ({
  className,
  horizontal,
  color,
  locked,
  icon: Icon,
  amount,
  qualified,
  title,
  onClick,
  content,
  qaTag,
  selected,
  inCarousel
}) => (
  <div
    className={classnames(
      className,
      styles.container,
      horizontal && styles.horizontal,
      selected && styles.selected,
      locked && styles.locked,
      inCarousel && styles.minimal
    )}
    data-qa={qaTag}
    onClick={onClick}
    onKeyDown={handleKeyNavForward(onClick)}
    role='button'
    tabIndex='0'
  >
    <div className={styles.gem}>
      <div className={styles.gemHead}>
        <div className={styles.iconHex}>
          <IconHexagon className={styles.hex}>
            <Icon className={styles.icon} />
          </IconHexagon>
        </div>
        <Lock
          blur='less'
          icon={horizontal ? undefined : <IconLock />}
          className={classnames(
            locked && styles.boosted,
            styles.amountContainer
          )}
          enabled={Boolean(locked)}
        >
          <Amount
            color={color}
            qualified={qualified}
            value={amount}
            inCarousel={inCarousel}
          />
        </Lock>
        <Text className={styles.title} align='center' weight='light'>
          {title}
        </Text>
      </div>
      <If condition={!selected && !locked && !inCarousel}>
        <div className={styles.gemFoot}>
          <Button minimal>
            <If condition={horizontal}>
              <FormattedMessage
                id='Homeowner.purchasePower.moreDetails'
                defaultMessage='More details on this'
              />
            </If>
            <If condition={!horizontal}>
              <FormattedMessage
                id='Homeowner.purchasePower.details'
                defaultMessage='Details'
              />
            </If>
          </Button>
        </div>
      </If>
    </div>
  </div>
)

Gem.defaultProps = {
  qualified: true
}

Gem.propTypes = {
  qaTag: PropTypes.string.isRequired
}

export default Gem
